import { useTranslation } from 'react-i18next'
import { Shuffle, Network, ArrowRight } from 'lucide-react'
import { Reveal } from './reveal'

export function ProblemSolution() {
  const { t } = useTranslation()

  return (
    <section className="mx-auto max-w-6xl px-6 py-24">
      <Reveal>
        <div className="relative grid grid-cols-1 items-stretch gap-6 md:grid-cols-[1fr_auto_1fr]">
          <div className="glass-card glass-hover group relative overflow-hidden rounded-2xl p-8">
            <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-muted/50 blur-2xl" aria-hidden />
            <div className="relative">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-[color-mix(in_oklch,var(--foreground)_10%,transparent)] bg-[color-mix(in_oklch,var(--foreground)_5%,transparent)] text-muted-foreground">
                <Shuffle className="h-6 w-6" />
              </div>
              <h3 className="mt-5 text-2xl font-bold tracking-tight text-foreground">
                {t('landing.problem.title')}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-muted-foreground">
                {t('landing.problem.body')}
              </p>
            </div>
          </div>

          <div className="hidden items-center justify-center md:flex" aria-hidden>
            <div className="glass-card flex h-12 w-12 items-center justify-center rounded-full text-foreground">
              <ArrowRight className="h-5 w-5" />
            </div>
          </div>

          <div className="glass-card glass-hover group relative overflow-hidden rounded-2xl p-8">
            <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-[color-mix(in_oklch,var(--foreground)_8%,transparent)] blur-2xl" aria-hidden />
            <div className="relative">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-[color-mix(in_oklch,var(--foreground)_12%,transparent)] bg-[color-mix(in_oklch,var(--foreground)_6%,transparent)] text-foreground">
                <Network className="h-6 w-6" />
              </div>
              <h3 className="mt-5 text-2xl font-bold tracking-tight text-foreground">
                {t('landing.solution.title')}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-muted-foreground">
                {t('landing.solution.body')}
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  )
}
